import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip,capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import queryGraphql from "../../helpers/ApiInterface";
interface ClusterRequestsTableProps {
	clusters: any;
	type: any;
	resourceStatuses: any;
}

const ClusterRequestsTable: React.FC<ClusterRequestsTableProps> = ({ clusters, type, resourceStatuses }: any) => {
	const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
	const navigate = useNavigate();


	return (
		<List sx={{ bgcolor: "#fafafa" }}>
			<ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
				<Box width="100%">
					<Grid container direction="row" alignItems="center">
						<Grid item xs={2}>
							<Typography fontSize="12px">CLUSTER NAME</Typography>
						</Grid>

						<Grid item textAlign="start" xs={3}>
							<Typography fontSize="12px">OWNER</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">REQUESTED ON</Typography>
						</Grid>
						<Grid textAlign="start" item xs={3}>
							<Typography fontSize="12px">ACTIONED BY/ REASON</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">ACTIONED ON</Typography>
						</Grid>
					</Grid>
				</Box>
			</ListItem>
			{clusters.map((cluster: any, index: number) => (
				<ListItem
					sx={{
						border: cardHoverIndex == index ? "1px solid #000" : "1px solid #00000000",
						mt: 1,
						cursor: "pointer",
						bgcolor: type == "active" ? "#FFFFFF" : type == "rejected" ? "#F0443810" : "#FDB02210",
						borderRadius: "8px",
					}}
					onClick={() => {
						navigate(`/requests/clusters/details/${cluster.id}`);
					}}
					onMouseEnter={() => setCardHoverIndex(index)}
					onMouseLeave={() => {
						setCardHoverIndex(null);
					}}
				>
					<Box width="100%" sx={{}}>
						<Grid container direction="row" alignItems="center" justifyContent="space-between">
							<Grid item xs={2}>
								{
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<RectangleIcon
											sx={{
												color:
													type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
												bgcolor:
													type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
												width: "4px",
												marginRight: "8px",
											}}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Medium">
											{cluster.clusterName}
										</Typography>{cluster && cluster.status === 'active' ? ( 
										  <Tooltip
											sx={{ whiteSpace: "pre-line" }}
											title={
											  <Box key="applications-tooltip"> 
												Current Status
												<br />
												{resourceStatuses.filter((e:any) => e.resourceId == cluster.id).map((e: any, index: number) => (
												  <React.Fragment key={index}>
													{capitalize(e.currentStatus)}
													<br />
												  </React.Fragment>
												))}
												
											  </Box>
											}
										  >
											<Avatar
											  src="/assets/info.svg"
											  alt="info"
											  sx={{ height: 16, width: 16, marginLeft: "4px" }}
											/>
										  </Tooltip>
										) : null}
									</Box>
								}
							</Grid>
							<Grid item xs={3}>
								{
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={cluster.clusterOwnerAvatar}
											alt={cluster.clusterOwner}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{cluster.clusterOwner}
										</Typography>
									</Box>
								}
							</Grid>
							<Grid item xs={2}>
								{
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{moment(cluster.createdAt).format("DD/MM/YYYY | hh:mm A")}
										</Typography>
									</Box>
								}
							</Grid>
							<Grid item xs={3}>
								{cluster.status != "pending" && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={cluster.clusterApproverAvatar}
											alt={cluster.clusterApprover}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>
											{cluster.clusterApprover}
										</Typography>
										{cluster.status == "rejected" && (
											<Tooltip title={`Reason: ${cluster.reasonForRejection}`}>
												<img src="/assets/info.svg" alt="info" />
											</Tooltip>
										)}
									</Box>
								)}
							</Grid>
							<Grid item xs={2}>
								{cluster.status != "pending" && (
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{moment(cluster.actionedAt).format("DD/MM/YYYY | hh:mm A")}
										</Typography>
									</Box>
								)}
							</Grid>
						</Grid>
					</Box>
				</ListItem>
			))}
		</List>
	);
};

export default ClusterRequestsTable;
